import React from 'react';
import { Card, CardBody, CardTitle, Spinner, Table, Badge } from 'reactstrap';
import { EditPatientButton } from '../../../../containers/Buttons';

const PatientProfileCard = (props: {
  displayName: string;
  firstName: string;
  familyName: string;
  birthDate: string;
  gender: string;
  mrn: string;
  active: boolean;
  status: string;
  loading?: boolean;
}) => (
  <Card>
    <CardBody>
      <EditPatientButton loading={props.loading} disabled={!props.active} />
      {!props.loading ? (
        <>
          <CardTitle>
            <h3>{props.displayName}</h3>
          </CardTitle>
          <Table>
            <tbody>
              <tr>
                <td>
                  <b>First Name</b>
                </td>
                <td>{props.firstName}</td>
              </tr>
              <tr>
                <td>
                  <b>Last Name</b>
                </td>
                <td>{props.familyName}</td>
              </tr>
              <tr>
                <td>
                  <b>Gender</b>
                </td>
                <td>{props.gender}</td>
              </tr>
              <tr>
                <td>
                  <b>Date of Birth</b>
                </td>
                <td>{props.birthDate}</td>
              </tr>
              <tr>
                <td>
                  <b>MRN</b>
                </td>
                <td>{props.mrn}</td>
              </tr>
              <tr>
                <td>
                  <b>Active</b>
                </td>
                <td>
                  {props.active ? (
                    <Badge color="success">Yes</Badge>
                  ) : (
                    <Badge color="danger">No</Badge>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Status</b>
                </td>
                <td>{props.status}</td>
              </tr>
            </tbody>
          </Table>
        </>
      ) : (
        <Spinner></Spinner>
      )}
    </CardBody>
  </Card>
);

export default PatientProfileCard;
